export function checkUsage(args: string[], expected: number, usage: string): string | null {
    if (args.length < expected) return `USAGE: ${usage}`;
    return null;
}